import styled, { css } from 'styled-components'

import { colors } from '../../../shared/styles/colors'

interface IMenuItemProps {
  onClick(): void
  selected?: boolean
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 224px;
  height: 100%;
  background-color: ${colors.white};
  z-index: 98;

  position: relative;

  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
`

export const BottomText = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 30px;
  text-align: center;
  font-size: 10px;
  color: ${colors.blue};
`

export const Menu = styled.div`
  padding-top: 20px;
  height: auto;
  width: 100%;
`

export const Line = styled.hr`
  margin: 10px 15px;
`

export const MenuItem = styled.div<IMenuItemProps>`
  display: flex;
  height: 37px;
  width: 100%;
  color: ${colors.blue};
  align-items: center;
  cursor: pointer;
  justify-content: space-between;

  &:hover {
    color: ${colors.white};
    background-color: ${colors.green};

    svg {
      color: ${colors.white};
    }
  }

  svg {
    color: ${colors.blue};
    &:hover {
      color: ${colors.white};
    }
  }

  ${props =>
    props.selected &&
    css`
      color: ${colors.white};
      background-color: ${colors.green};

      svg {
        color: ${colors.white};
      }
    `}
`

export const MenuTitle = styled.span`
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 700px;
`

export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-left: 20px;
`

export const MenuIcon = styled.div`
  margin-right: 10px;
  font-size: 10px;
`
